export default "__VITE_ASSET__bfee3a03__"